import styled, { css } from 'styled-components';
import { ButtonContainer } from '../../button';
import { LinkContainer } from '../../link';
import { pxToRem } from '../../../design-tokens/style-utilities';
import { CardButtonWrapperContainer } from './card-button-wrapper.styled';
/**
 * Card button footer
 */
export const cardButtonFooterStyles = ({ theme, $useRedesign, }) => css `
	display: flex;
	justify-content: flex-end;
	margin-top: ${pxToRem(theme.spacing['200'])};

	${$useRedesign &&
    css `
		> ${ButtonContainer} {
			margin: ${pxToRem(theme.spacing['200'])};
			margin-bottom: ${pxToRem(theme.spacing['400'])};
		}
	`}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		margin-top: ${pxToRem(theme.spacing['300'])};
	}
`;
export const CardButtonFooter = styled.div `
	${cardButtonFooterStyles}
`;
/**
 * Card footer
 */
export const cardFooterStyles = ({ theme, $useBackground, $useRedesign, }) => css `
	display: block;
	padding: ${pxToRem(theme.spacing['300'])};
	border-radius: 0 0 ${pxToRem(theme.borderRadius.m)} ${pxToRem(theme.borderRadius.m)};
	border-top: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.light.dividerCards};
	background-color: ${theme.colors.blanc.bgCards};

	> ${CardButtonWrapperContainer} {
		padding-bottom: 0;
	}

	${$useRedesign &&
    css `
		display: flex;
		flex-direction: column;
		padding: ${pxToRem(theme.spacing['300'])} 0 0 0;
		border-top: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.extralight.borderCards};

		${LinkContainer} {
			margin: 0;

			&:not(:only-child):first-child {
				margin-bottom: ${pxToRem(theme.spacing['200'])};
			}

			&:not(:only-child):last-child {
				margin-top: ${pxToRem(theme.spacing['200'])};
			}
		}

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			${LinkContainer} {
				&:not(:only-child):first-child {
					margin-bottom: 0;
				}

				&:not(:only-child):last-child {
					margin-top: 0;
				}

				&:not(:first-child) {
					margin-left: ${pxToRem(theme.spacing['400'])};
				}
			}
		}
	`}

	${!$useBackground &&
    css `
		background-color: transparent;
	`}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		${$useRedesign &&
    css `
			flex-direction: row;
		`}
	}

	p:first-child,
	p:last-child {
		margin-bottom: 0;
	}

	&:not(:last-child) {
		margin-bottom: ${pxToRem(theme.spacing['300'])};
	}
`;
export const CardFooterContainer = styled.footer `
	${cardFooterStyles}
`;
